import { render, staticRenderFns } from "./CreateXButtonGroup.vue?vue&type=template&id=5a9082c8&"
import script from "./CreateXButtonGroup.vue?vue&type=script&lang=js&"
export * from "./CreateXButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports